import { Button, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { FieldSearchModalProps } from "./interface";
import { DotsIcon } from "../Icon";
import { forwardRef } from "react";
import { CloseIcon } from "@chakra-ui/icons";

const FieldSearchModal = forwardRef<HTMLInputElement, FieldSearchModalProps>(
  ({ onSearchClick, onClearClick, showClearButton, ...props }, ref) => {
    return (
      <InputGroup>
        <Input {...props} pr="3rem" type="text" isDisabled ref={ref} />
        <InputRightElement width="3rem" gap={2}>
          {onClearClick && showClearButton && (
            <Button
              h="1.75rem"
              variant="clean"
              size="sm"
              onClick={() => onClearClick()}
            >
              <CloseIcon boxSize="10px" />
            </Button>
          )}
          <Button
            h="1.75rem"
            variant="clean"
            size="sm"
            onClick={() => onSearchClick()}
          >
            <DotsIcon />
          </Button>
        </InputRightElement>
      </InputGroup>
    );
  }
);

export default FieldSearchModal;
